import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

let wasHideKlarnaTestTracked = false;

const HIDE_KLARNA_ON_CHECKOUT = 'hideKlarnaOnCheckout';

export const resetHideKlarnaOnCheckoutTracking = (): void => {
    wasHideKlarnaTestTracked = false;
};

export const isHideKlarnaOnCheckoutTestVariant = (): boolean =>
    getAbTestV2(HIDE_KLARNA_ON_CHECKOUT)?.variant === 'variant';

export const trackHideKlarnaOnCheckoutTestVariant = (): void => {
    if (!wasHideKlarnaTestTracked) {
        trackAbTestV2Variant(HIDE_KLARNA_ON_CHECKOUT);
        wasHideKlarnaTestTracked = true;
    }
};
